import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './WithLegendDot.module.scss';
/** Adds a legend dot to the left of the children. Used in graph legends and tooltips. */ export default function WithLegendDot(props) {
    const { children, color, className, testId } = props, rest = _object_without_properties(props, [
        "children",
        "color",
        "className",
        "testId"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: cn(styles.root, className),
        "data-testid": testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.dot,
                style: {
                    background: color
                }
            }),
            children
        ]
    }));
}
